import Keycloak from "keycloak-js";

import { SSO_CONFIG } from "../constants/config";

export const keycloak_instance = new Keycloak(SSO_CONFIG);

const MIN_VALIDITY_KEYCLOAK = 30;
const ONLOAD_OPTION = "login-required";

export async function init(onLoad = ONLOAD_OPTION) {
  try {
    const authenticated = await keycloak_instance.init({
      onLoad,
      checkLoginIframe: false,
      pkceMethod: "S256",
      useNonce: false
    });

    console.log("keycloak init authenticated", authenticated);
    return authenticated;
  } catch (err) {
    console.error("keycloak init FAILED:", err);
    throw err;
  }
}

// export const login = async (redirectUri) =>
//   await keycloak_instance.login({
//     redirectUri: redirectUri || window.location.href,
//   });

// export const checkSSO = async () => await init("check-sso");

export const logout = () =>
  new Promise((resolve, reject) =>
    keycloak_instance
      .logout()
      .then(resolve)
      .catch(reject),
  );

export const getProfile = () =>
  new Promise((resolve, reject) =>
    keycloak_instance
      .loadUserInfo()
      .then(resolve)
      .catch(reject),
  );

export const refreshToken = (seconds) =>
  new Promise((resolve, reject) =>
    keycloak_instance
      .updateToken(seconds || MIN_VALIDITY_KEYCLOAK)
      .then((refreshed) => {
        console.log("refreshed token", refreshed);
        resolve(refreshed);
      })
      .catch((err) => {
        console.log("refreshed token err", err);
        reject(err);
      }),
  );

export const getToken = () => keycloak_instance.token;
